import Api from "./api"

export default {
    store(data) {
        return Api().post("/tickets/store", data)
    },

    myTickets(userID) {
        return Api().get("/tickets/user/" + userID)
    },

		show(ticketID) {
			return Api().get("/ticket/show/"+ticketID)
		}
}